export const isSet = (value) => value != null;
